import { createLazyDialog } from '@core/modal'

import type { TAudioActionsDialogProps } from './AudioActionsDialog.types'

export const AsyncAudioActionsDialog = createLazyDialog<
    TAudioActionsDialogProps,
    'AudioActionsDialog'
>(
    () => import(/* webpackChunkName: 'dialog-audio-actions' */ './AudioActionsDialog'),
    'AudioActionsDialog',
)
